export const pulseCheckTranslations = {
  pt: {
    badge: "Quick Assessment",
    export_pdf: "Export PDF",
    back_to_pulse: "Voltar ao Pulse",
    title: "Pulse Check",
    subtitle: "Descobre a distribuição financeira sugerida para o teu negócio",
    description:
      "Em 2 minutos, insere alguns valores e descobre como poderias organizar o dinheiro da tua empresa de forma mais saudável.",
    audit_note:
      "Isto não é auditoria nem contabilidade. É um teste exploratório para criar consciência e curiosidade.",
    highlight:
      "No final, vais ver uma distribuição sugerida de envelopes adaptada ao teu negócio.",
    inputs_title: "Inputs",
    inputs_period: "Últimos 12 meses",
    organization_label: "Nome da organização",
    inputs_required: "Campos obrigatórios",
    input_gross_revenue: "Receita Bruta (com IVA)",
    input_gross_revenue_note:
      "Total faturado/recebido nos últimos 12 meses, incluindo IVA.",
    input_output_vat: "IVA cobrado nas vendas (Output VAT)",
    input_output_vat_note:
      "IVA cobrado aos clientes. É pass-through — não é receita nem despesa. Se não cobras IVA, coloca 0.",
    input_materials: "Materiais & Subcontratos",
    input_materials_note:
      "Custos diretos de entrega (materiais, freelancers). São pass-through e não fazem parte da margem.",
    input_profit: "Lucro real separado (se existiu)",
    input_profit_note:
      "Lucro que já separaste do negócio. Se nunca separaste lucro, coloca 0.",
    input_owner_pay: "Remuneração do Sócio (Owner Pay)",
    input_owner_pay_note:
      "O que retiraste regularmente do negócio para viver. Não inclui lucros extraordinários.",
    input_tax_reserve: "Reserva Fiscal atual (Tax Reserve)",
    input_tax_reserve_note:
      "Dinheiro reservado para impostos e obrigações da empresa. Não é IVA.",
    input_operating_expenses: "Despesas Operacionais totais",
    input_operating_expenses_note:
      "Custos do dia-a-dia (renda, software, equipa, etc.), com IVA se estiver misturado.",
    input_operating_expenses_vat: "IVA pago ao Estado incluído nas Despesas Operacionais",
    input_operating_expenses_vat_note:
      "IVA incluído nas despesas acima. Se não estiver incluído, coloca 0.",
    clear_values: "Limpar valores",
    suggested_distribution_title: "Suggested Envelope Distribution",
    suggested_distribution_caption: "Computed Values (Excel Model EU)",
    distributable_revenue: "Receita Distribuível (sem IVA)",
    real_revenue: "Real Revenue (EU) = Receita Distribuível − Materiais/Subs",
    operating_expenses_clean: "Despesas Operacionais (sem IVA pass-through)",
    vat_note: "IVA é pass-through: deve ser separado antes de qualquer distribuição.",
    reference_targets_title: "Reference Targets (Europe)",
    reference_targets_caption: "Valores de referência configuráveis por faixa de receita.",
    reference_band: "Faixa Real Revenue",
    category_profit: "Lucro",
    category_owner_pay: "Owner Pay",
    category_tax_reserve: "Reserva Fiscal",
    category_operations: "Operações",
    reference_total: "Total",
    reference_notes: "Notas",
    band_0_250: "€0–€250k",
    band_0_250_notes: "Conservador (serviços/SaaS).",
    band_250_500: "€250k–€500k",
    band_250_500_notes: "Bom ponto de partida EU.",
    band_500_1m: "€500k–€1M",
    band_500_1m_notes: "Mais disciplina; lucro sobe.",
    band_1m_5m: "€1M–€5M",
    band_1m_5m_notes: "Escala; reforçar reservas.",
    band_5m_plus: "€5M+",
    band_5m_plus_notes: "Escala; reforçar reservas.",
    band_selected: "Atual",
    select_targets_title: "Select Targets (automatic, with optional override)",
    select_targets_description:
      "Ajusta as metas se quiseres. Se não mudares nada, usamos os valores de referência.",
    select_targets_real_revenue_label: "Real Revenue (EU)",
    select_targets_band_label: "Faixa selecionada",
    select_targets_real_revenue: "Real Revenue (EU): {{amount}}",
    select_targets_band: "Faixa selecionada: {{band}}",
    select_targets_category: "Categoria",
    select_targets_reference: "Target % (referência)",
    select_targets_override: "Override % (opcional)",
    select_targets_final: "Final %",
    select_targets_hint:
      "Se não alterares nada, usamos os valores de referência.",
    instant_assessment_title: "Instant Assessment",
    instant_assessment_description:
      "Comparação entre os teus valores atuais e os targets de referência do modelo EU.",
    assessment_band: "Faixa de receita selecionada: {{band}}",
    assessment_row: "Linha",
    assessment_actual: "ACTUAL (€)",
    assessment_actual_pct: "ACTUAL %",
    assessment_target_pct: "TARGET %",
    assessment_target: "TARGET €",
    assessment_delta: "DELTA (A - T)",
    assessment_correction: "CORREÇÃO",
    assessment_notes: "Notas",
    row_gross_revenue: "Receita Bruta (com IVA) [informativo]",
    row_gross_revenue_note: "Não entra na análise; serve para reconciliação.",
    row_vat: "IVA (pass-through) [informativo]",
    row_vat_note: "Deve sair primeiro para o balde IVA.",
    row_real_revenue: "Real Revenue (EU) (sem IVA)",
    row_real_revenue_note: "Base de cálculo.",
    row_profit: "Lucro (Profit)",
    row_profit_note: "Ideal: separar primeiro (pode começar em 1%).",
    row_owner_pay: "Remuneração do Proprietário (Owner Pay)",
    row_owner_pay_note: "Salário/compensação do(s) sócio(s).",
    row_tax_reserve: "Reserva Fiscal (Tax Reserve)",
    row_tax_reserve_note: "Reserva para IRC/SS empresa/etc. (não IVA).",
    row_operating_expenses: "Despesas Operacionais (sem IVA pass-through)",
    row_operating_expenses_note: "Safe-to-Spend = Operações.",
    correction_increase: "aumentar",
    correction_decrease: "reduzir",
    correction_ok: "ok",
    instant_assessment_warning:
      "Este Pulse Check é um teste exploratório, não é contabilidade, auditoria, nem consultoria financeira.",
    summary_title: "Your Pulse Check Summary",
    summary_description:
      "Estes valores representam a estrutura de referência que o Pulse recomendaria diariamente, considerando a dimensão do teu negócio.",
    summary_description_secondary:
      "Estes valores mostram como o dinheiro do teu negócio está atualmente distribuído. No Pulse, esta estrutura é monitorizada e ajustada automaticamente todos os dias.",
    summary_current: "Atual",
    summary_starting_point: "Ponto de partida",
    summary_goal: "Objetivo",
    summary_profit_title: "Lucro",
    summary_profit_description: "O teu retorno por assumir risco e investir.",
    summary_owner_pay_title: "Owner's Pay",
    summary_owner_pay_description: "O que retiras regularmente para viver.",
    summary_tax_reserve_title: "Reserva Fiscal",
    summary_tax_reserve_description: "Futuras obrigações fiscais protegidas.",
    summary_operating_expenses_title: "Despesas Operacionais",
    summary_operating_expenses_description: "Custos diários do negócio.",
    summary_footer:
      "Importante: esta é uma sugestão aproximada, não uma regra fixa. Cada negócio é único e os valores finais devem ser ajustados à tua realidade.",
    footer_disclaimer:
      "Este Pulse Check não é contabilidade, auditoria ou consultoria financeira. É um exercício de consciência criado pela MoneyLights.",
  },
  en: {
    badge: "Quick Assessment",
    export_pdf: "Export PDF",
    back_to_pulse: "Back to Pulse",
    title: "Pulse Check",
    subtitle: "Discover the suggested financial distribution for your business",
    description:
      "In 2 minutes, enter a few values and discover how you could organize your business money in a healthier way.",
    audit_note:
      "This is not an audit or accounting. It's an exploratory check to create awareness and curiosity.",
    highlight:
      "At the end, you'll see a suggested envelope distribution adapted to your business.",
    inputs_title: "Inputs",
    inputs_period: "Last 12 months",
    organization_label: "Organization name",
    inputs_required: "Required fields",
    input_gross_revenue: "Gross Revenue (including VAT)",
    input_gross_revenue_note:
      "Total invoiced/received in the last 12 months, including VAT.",
    input_output_vat: "VAT charged on sales (Output VAT)",
    input_output_vat_note:
      "VAT charged to clients. It's pass-through — not revenue or expense. If you don't charge VAT, enter 0.",
    input_materials: "Materials & Subcontracts",
    input_materials_note:
      "Direct delivery costs (materials, freelancers). They are pass-through and not part of margin.",
    input_profit: "Actual profit separated (if any)",
    input_profit_note:
      "Profit you've already separated from the business. If you never separated profit, enter 0.",
    input_owner_pay: "Owner's pay (Owner Pay)",
    input_owner_pay_note:
      "What you regularly withdraw from the business to live. Don't include extraordinary profits.",
    input_tax_reserve: "Current Tax Reserve (Tax Reserve)",
    input_tax_reserve_note:
      "Money reserved for corporate taxes and obligations. Not VAT.",
    input_operating_expenses: "Total Operating Expenses",
    input_operating_expenses_note:
      "Day-to-day costs (rent, software, team, etc.), including VAT if mixed in.",
    input_operating_expenses_vat: "VAT paid to state included in Operating Expenses",
    input_operating_expenses_vat_note:
      "VAT included in the expenses above. Enter 0 if it's not included.",
    clear_values: "Clear values",
    suggested_distribution_title: "Suggested Envelope Distribution",
    suggested_distribution_caption: "Computed Values (Excel Model EU)",
    distributable_revenue: "Distributable Revenue (excluding VAT)",
    real_revenue: "Real Revenue (EU) = Distributable Revenue – Materials/Subs",
    operating_expenses_clean: "Operating Expenses (excluding VAT pass-through)",
    vat_note: "VAT is pass-through: cleared before any distribution.",
    reference_targets_title: "Reference Targets (Europe)",
    reference_targets_caption: "Configurable reference values by revenue band.",
    reference_band: "Real Revenue Band",
    category_profit: "Profit",
    category_owner_pay: "Owner Pay",
    category_tax_reserve: "Tax Reserve",
    category_operations: "Operations",
    reference_total: "Total",
    reference_notes: "Notes",
    band_0_250: "€0–€250k",
    band_0_250_notes: "Conservative (services/SaaS).",
    band_250_500: "€250k–€500k",
    band_250_500_notes: "Good EU starting point.",
    band_500_1m: "€500k–€1M",
    band_500_1m_notes: "More discipline; profit rises.",
    band_1m_5m: "€1M–€5M",
    band_1m_5m_notes: "Scale; reinforce reserves.",
    band_5m_plus: "€5M+",
    band_5m_plus_notes: "Scale; reinforce reserves.",
    band_selected: "Actual",
    select_targets_title: "Select Targets (automatic, with optional override)",
    select_targets_description:
      "Adjust targets if you want. If you don’t change anything, we use the reference values.",
    select_targets_real_revenue_label: "Real Revenue (EU)",
    select_targets_band_label: "Selected band",
    select_targets_real_revenue: "Real Revenue (EU): {{amount}}",
    select_targets_band: "Selected band: {{band}}",
    select_targets_category: "Category",
    select_targets_reference: "Target % (reference)",
    select_targets_override: "Override % (optional)",
    select_targets_final: "Final %",
    select_targets_hint:
      "If you don’t change anything, we use the reference values.",
    instant_assessment_title: "Instant Assessment",
    instant_assessment_description:
      "Comparison between your current values and the Excel Model EU reference targets.",
    assessment_band: "Selected revenue band: {{band}}",
    assessment_row: "Row",
    assessment_actual: "ACTUAL (€)",
    assessment_actual_pct: "ACTUAL %",
    assessment_target_pct: "TARGET %",
    assessment_target: "TARGET €",
    assessment_delta: "DELTA (A - T)",
    assessment_correction: "CORRECTION",
    assessment_notes: "Notes",
    row_gross_revenue: "Gross Revenue (incl. VAT) [informational]",
    row_gross_revenue_note: "Not included in analysis; for reconciliation.",
    row_vat: "VAT (pass-through) [informational]",
    row_vat_note: "Must go first to the VAT bucket.",
    row_real_revenue: "Real Revenue (EU) (ex VAT)",
    row_real_revenue_note: "Calculation base.",
    row_profit: "Profit",
    row_profit_note: "Ideal: separate first (you can start at 1%).",
    row_owner_pay: "Owner's Pay",
    row_owner_pay_note: "Salary/compensation for owner(s).",
    row_tax_reserve: "Tax Reserve",
    row_tax_reserve_note: "Reserve for corporate taxes/etc. (not VAT).",
    row_operating_expenses: "Operating Expenses (ex VAT pass-through)",
    row_operating_expenses_note: "Safe-to-Spend = Operations.",
    correction_increase: "increase",
    correction_decrease: "decrease",
    correction_ok: "ok",
    instant_assessment_warning:
      "This Pulse Check is an exploratory tool, not accounting, auditing, or financial consulting.",
    summary_title: "Your Pulse Check Summary",
    summary_description:
      "These values represent the reference structure Pulse would use daily, considering your business size.",
    summary_description_secondary:
      "These values show how your business money is currently distributed. In Pulse, this structure is monitored and adjusted automatically on a daily basis.",
    summary_current: "Current",
    summary_starting_point: "Starting point",
    summary_goal: "Goal",
    summary_profit_title: "Profit",
    summary_profit_description: "Your reward for risking and investing.",
    summary_owner_pay_title: "Owner's Pay",
    summary_owner_pay_description: "What you take regularly to live.",
    summary_tax_reserve_title: "Tax Reserve",
    summary_tax_reserve_description: "Future taxes and obligations protected.",
    summary_operating_expenses_title: "Operating Expenses",
    summary_operating_expenses_description: "Day-to-day business costs.",
    summary_footer:
      "Important: this is an approximate suggestion, not a fixed rule. Each business is unique and final values should be adjusted to your reality.",
    footer_disclaimer:
      "This Pulse Check is not accounting, auditing, or financial consulting. It is an awareness exercise by MoneyLights.",
  },
  es: {},
  et: {},
  de: {},
  fr: {},
  it: {},
  nl: {},
  sv: {},
  da: {},
  fi: {},
};

const fallback = pulseCheckTranslations.en;

(["es", "et", "de", "fr", "it", "nl", "sv", "da", "fi"] as const).forEach((lang) => {
  pulseCheckTranslations[lang] = { ...fallback };
});
